<template>
  <div id="work" class="work up">
    <v-container
      class="py-0 px-0 width-container-rewrite animation"
      style="animation-delay: 1.4s"
    >
      <div>
        <!-- ***********************row mobile******************* -->
        <v-row class="my-7 mt-sm-10 mb-8 px-7 d-md-none">
          <v-col class="margin-top-clients-mobile">
            <div class="link-router">
              <span
                class="title-app color-black underline"
                @click="menuProjectsNew = !menuProjectsNew"
                >{{ $t("btnClients") }}</span
              >
            </div>

            <!-- tablet menu projects -->
            <div class="d-none d-sm-block d-md-none">
              <transition name="fade">
                <div
                  v-if="menuProjectsNew"
                  class="d-flex mt-4"
                  id="menu-expand-mobile"
                >
                  <div>
                    <div v-for="(proyecto, ipc) in proyectos" :key="ipc">
                      <template v-if="ipc % 3 == 0">
                        <span @mouseover="mouseIn(ipc)" @mouseout="mouseOut()">
                          <router-link
                            class="text-app-2 SctoGroteskAMedium ns color-black"
                            :to="'/project/' + proyecto.url"
                            >{{ proyecto.name }}</router-link
                          >
                        </span>
                      </template>
                    </div>
                  </div>

                  <div>
                    <div v-for="(proyecto, ipc2) in proyectos" :key="ipc2">
                      <template v-if="ipc2 % 3 == 1">
                        <span @mouseover="mouseIn(ipc2)" @mouseout="mouseOut()">
                          <router-link
                            class="text-app-2 SctoGroteskAMedium ns color-black"
                            :to="'/project/' + proyecto.url"
                            >{{ proyecto.name }}</router-link
                          >
                        </span>
                      </template>
                    </div>
                  </div>

                  <div>
                    <div v-for="(proyecto, ipc3) in proyectos" :key="ipc3">
                      <template v-if="ipc3 % 3 == 2">
                        <span @mouseover="mouseIn(ipc3)" @mouseout="mouseOut()">
                          <router-link
                            class="text-app-2 SctoGroteskAMedium ns color-black"
                            :to="'/project/' + proyecto.url"
                            >{{ proyecto.name }}</router-link
                          >
                        </span>
                      </template>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
            <!-- tablet menu projects -->

            <!-- mobile menu projects -->
            <div class="d-sm-none">
              <transition name="fade">
                <div
                  v-if="menuProjectsNew"
                  class="d-flex mt-4"
                  id="menu-expand-mobile"
                >
                  <div>
                    <div v-for="(proyecto, ipc) in proyectos" :key="ipc">
                      <template v-if="ipc % 2 == 0">
                        <span>
                          <router-link
                            class="text-app-2 SctoGroteskAMedium ns color-black"
                            :to="'/project/' + proyecto.url"
                            >{{ proyecto.name }}</router-link
                          >
                        </span>
                      </template>
                    </div>
                  </div>

                  <div class="pl-10">
                    <div v-for="(proyecto, ipc2) in proyectos" :key="ipc2">
                      <template v-if="ipc2 % 2 == 1">
                        <span>
                          <router-link
                            class="text-app-2 SctoGroteskAMedium ns color-black"
                            :to="'/project/' + proyecto.url"
                            >{{ proyecto.name }}</router-link
                          >
                        </span>
                      </template>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
            <!-- mobile menu projects -->
          </v-col>
        </v-row>
        <!-- ***********************row mobile******************* -->

        <!--  -->
        <!-- ***********************row desk******************* -->
        <v-row
          class="d-none d-sm-flex animation"
          style="animation-delay: 1.5s"
          no-gutters
        >
          <template v-for="(proyecto, i) in proyectos">
            <v-col
              v-bind:id="'project-' + proyecto._id"
              :projectId="proyecto._id"
              cols="6"
              sm="4"
              class="work-project"
              :class="seleccionarClase(i) + ' project-' + proyecto._id"
              :key="i"
              :style="'animation-delay:' + (i < 8) * 1 + 's;'"
              @mouseover="mouseIn(proyecto._id)"
              @mouseout="mouseOut()"
            >
              <router-link :to="'/project/' + proyecto.url">
                <div class="wrap position-relative">
                  <template v-if="proyecto.cover != null">
                    <v-img
                      :src="
                        'https://www.chaptercms.actstudio.xyz/storage/uploads' +
                        proyecto.cover.path
                      "
                      class="d-block img-clients-projects"
                    ></v-img>
                  </template>
                  <div class="overlay">
                    <div class="content">
                      <span
                        class="d-block title-app title-clients-projects white--text"
                        style="word-wrap: break-word"
                        >{{ proyecto.name }}</span
                      >
                      <span
                        class="d-block white--text feed-description-project SctoGroteskARegular"
                        >{{ proyecto.description }}</span
                      >
                    </div>
                  </div>
                </div>
              </router-link>
            </v-col>
          </template>
        </v-row>
        <!-- ***********************/row desk******************* -->

        <!-- ***********************row mobile****************** -->
        <v-row class="px-0 pt-0 pt-xl-11 d-sm-none">
          <template v-for="(proyecto, i) in proyectos">
            <v-col
              cols="6"
              sm="4"
              class="pa-0 work-project"
              :key="i"
              @mouseover="mouseIn(i)"
              @mouseout="mouseOut()"
            >
              <router-link :to="'/project/' + proyecto.url">
                <div class="wrap position-relative">
                  <template v-if="proyecto.cover != null">
                    <v-img
                      :src="
                        'https://www.chaptercms.actstudio.xyz/storage/uploads' +
                        proyecto.cover.path
                      "
                      class="d-block"
                    ></v-img>
                  </template>
                  <div class="overlay">
                    <div class="content">
                      <span
                        class="d-block title-app title-clients-projects white--text"
                        style="word-wrap: break-word"
                        >{{ proyecto.name }} –</span
                      >
                      <span
                        class="d-block white--text pixels-general-description pt-2"
                        >{{ proyecto.description }}</span
                      >
                    </div>
                  </div>
                </div>
              </router-link>
            </v-col>
          </template>
        </v-row>
        <!-- ***********************/row mobile****************** -->

        <!-- form -->
       <v-row no-gutters class="animation-work margin-in-form">
          <v-col cols="12">
            <contactForm paddingClasses="px-11 px-sm-6 px-md-0"></contactForm>
          </v-col>
       </v-row>
        <!-- /form -->

        <!-- btn ir arriba -->
        <v-row
          align="center"
          justify="space-between"
          class="pl-3 arrow-information-top"
        >
          <v-col
            cols="auto"
            class="justify-start align-self-end py-2 px-10 px-md-3 top-col"
          >
            <span @click="scrollToTop()" class="cursor-pointer">
              <div class="next-btn">
                <v-row align="center">
                  <v-col cols="auto" class="px-0">
                    <v-img
                      src="@/assets/icons/triangle.svg"
                      class="flecha-arriba-information"
                    ></v-img>
                  </v-col>

                  <v-col cols="auto" class="px-3 py-3 text-left transform-top">
                    <span class="title-app not-text-transform opacity-60"
                      >Top</span
                    >
                  </v-col>
                </v-row>
              </div>
            </span>
          </v-col>

          <!-- tablet vertical -->
          <v-col
            cols="auto"
            class="py-0 px-sm-10 px-md-3 d-none d-sm-block d-md-none"
          >
            <span class="small-text top-col">
              <span class="opacity-60 cursor-pointer">Terms & Conditions</span>
              <span class="padding-x-terms">/</span>
              <span class="opacity-60 cursor-pointer">Privacy Policy</span>
            </span>
          </v-col>
          <!-- /tablet vertical -->

          <!-- mobile -->
          <v-col cols="auto" class="py-0 px-10 d-sm-none">
            <div class="title-app hidden-md-and-up" id="chapterCopy">
              &copy; {{ date }}
            </div>
          </v-col>
          <!-- /mobile -->
        </v-row>
        <!-- /btn ir arriba -->

      </div>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import VueScrollTo from "vue-scrollto/vue-scrollto.js";
import contactForm from "../components/forms/contact";

// You can also pass in the default options
Vue.use(VueScrollTo, {
  el: "#right-column",
  container: "#right-column",
});

export default {
  components: {
    contactForm
  },
  data() {
    return {
      proyectos: [],
      isActive: false,

      // menú projects
      menuProjectsNew: false
    };
  },
  computed: {
    date() {
      var dateToFormat = new Date();
      var year = dateToFormat.getFullYear();

      return year;
    },
    lang() {
      return this.$i18n.locale;
    },
  },
  watch: {
    lang() {
      if (this.$i18n.locale == "en") {
        //promesa para traer proyectos
        fetch(
          "https://www.chaptercms.actstudio.xyz/api/collections/get/Projects?token=6f2367a659983f01bf66f378fcfcd3",
          {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              filter: {
                published: true,
              },
              sort: {
                _o: 1,
              },
            }),
          }
        )
          .then((res) => res.json())
          .then((res) => (this.proyectos = res.entries));
      } //endif
      else if (this.$i18n.locale == "es") {
        //promesa para traer proyectos
        fetch(
          "https://www.chaptercms.actstudio.xyz/api/collections/get/Projects?token=6f2367a659983f01bf66f378fcfcd3",
          {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              filter: {
                published: true,
              },
              lang: "es",
              sort: {
                _o: 1,
              },
            }),
          }
        )
          .then((res) => res.json())
          .then((res) => (this.proyectos = res.entries));
      }
    },
  },
  mounted: function () {
    //emitir valor de variable
    this.$emit("update", 3);

    //escuchar evento scroll
    var rightColumn = document.getElementById("right-column");
    rightColumn.addEventListener("scroll", this.mostrarScroll);
  },
  created: function () {

    if (this.$i18n.locale == "en") {
      //promesa para traer proyectos
      fetch(
        "https://www.chaptercms.actstudio.xyz/api/collections/get/Projects?token=6f2367a659983f01bf66f378fcfcd3",
        {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            filter: {
              published: true,
            },
            sort: {
              _o: 1,
            },
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => (this.proyectos = res.entries));
    } //endif
    else if (this.$i18n.locale == "es") {
      //promesa para traer proyectos
      fetch(
        "https://www.chaptercms.actstudio.xyz/api/collections/get/Projects?token=6f2367a659983f01bf66f378fcfcd3",
        {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            filter: {
              published: true,
            },
            lang: "es",
            sort: {
              _o: 1,
            },
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => (this.proyectos = res.entries));
    }
  },
  methods: {
    scrollToTop: function () {
      VueScrollTo.scrollTo("#right-column", 500);
      // var rightColumn = document.getElementById("right-column");
      // console.log(rightColumn);
      // var element = document.querySelectorAll('.up');

      // rightColumn.scrollTo({ top: rightColumn, behavior: "smooth" });
    },
    mouseIn: function (i) {
      /*método cuando haces hover en proyecto
      selecciona el proyecto en el menú de projects
    */
      var ns = document.querySelectorAll(".ns"); //selecciona la clase del menú de projects

      for (var x = 0; x < ns.length; x++) {
        //recorre cada proyecto del menú de projects
        //valida si el parámetro enviado del proyecto(índice) de cada proyecto en el que se hace hover es igual a cada elemento del menú de proyects y le agrega una clase a cada elemento para saber el proyecto en el que se hizo project

        if (ns[x].classList.contains(i)) {
          ns[x].classList.add("change-black");
        }
      }
    },
    mouseOut: function () {
      /*método cuando dejas de hacer hover en los proyectos
       */
      var ns = document.querySelectorAll(".ns"); //selecciona la clase del menú de projects
      for (var x = 0; x < ns.length; x++) {
        //recorre cada proyecto del menú de projects
        ns[x].classList.remove("change-black"); //le remueve la clase que se le pone en el método mouseIn
      }
    },
    mostrarScroll: function (e) {
      let animado = document.querySelectorAll(".animation-work"); //selecciona cada elemento con esa clase
      var rightColumn = document.getElementById("right-column"); //selecciona el lugar en donde se va a hacer scroll
      let scrollTop = rightColumn.scrollTop; //
      for (var i = 0; i < animado.length; i++) {
        //recorrer los elementos con clase animado
        let alturaAnimado = animado[i].offsetTop; //asignar las coordenadas del elemento
        if (alturaAnimado - 800 < scrollTop) {
          //validar si la altura de los elementos es menor que la altura del scroll
          animado[i].style.opacity = 1; //a cada elemento darles aparecerlos en scroll
        }
      }
    },
    seleccionarClase: function (n) {
      if (n < 9) {
        return "animation";
      } else {
        return "animation-work";
      }
    }
  },
};
</script>